const digest = '319f6d49f7e417423ef0635152610a15778ada51708ff0c754c9875c3634c8f8';
const css = `aside._offlineWarning_1xfcy_1{position:fixed;width:100%;z-index:1002}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'offlineWarning': '_offlineWarning_1xfcy_1' };
export const offlineWarning = '_offlineWarning_1xfcy_1';
export { css, digest };